<div class="modal-body customModalBody">

      <div class="modal-header customBlueHeader">
        <p class="modal-title">Add User</p>

        <button type="button" class="close" aria-label="Close" (click)="modelClose()">
            <span aria-hidden="true">&times;</span>
          </button>
      </div>

    <form [formGroup]="addUserForm" (ngSubmit)="addUserData(addUserForm)">
        <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="userName" placeholder="userName">
        </div>
        <div class="form-group">
            <label>Email</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="userEmail" placeholder="userEmail">
        </div>
        <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="userMobileNo" placeholder="userMobileNo">
        </div>
        <div class="form-group">
            <label>Tenant Code</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="tenantCode" placeholder="tenantCode">
        </div>
        <div class="form-group">
            <label>ORG Code</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="orgCode" placeholder="orgCode">
            <!--<input type="text" (keyup)="getTestNameValues($event)" list="testNameList" class="form-control col-form-label-sm"  (blur)="getPrice()" id="testNameId" formControlName="testname"/>-->
            <!--<datalist id="testNameList" aria-autocomplete="both">
                <option *ngFor="let item of testNameList" [value]="item.name">{{item.name}}</option>
              </datalist>-->
        </div>
       
        <div class="form-group">
            <label>Associatee Name</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="associateName" placeholder="associateName">
        </div>

        <div class="form-group">
            <label>Branch Name</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="branchName" placeholder="branchName">
        </div>

        <div class="form-group">
            <label>Role Type</label>
            <input type="text" class="form-control col-form-label-sm" formControlName="roleType" placeholder="roleType">
        </div>

        <div class="modal-footer customModalFooter bdr-none">
            <button class="btn green_btn" type="submit">Add User</button> 
        </div>

    </form>



</div>